import { adaptNotificacionesPagina, type NotificacionesPagina } from '@/shared/domain/adapters';
import { apiAxios } from '../api';
import { qs, toResult } from '../handlers';
import type { ApiResult } from '../types';
import { priv, segmento, sinCuerpo, type RequestOpts } from './common';

/** Bandeja de la cuenta (/v1/notificaciones). Todas privadas. */
export interface ListarNotificacionesParams {
  page?: number;
  limit?: number;
  leida?: boolean;
}

export const notificacionesApi = {
  /** Paginada, con `noLeidas` (total de la cuenta, no solo de la página). */
  listar: (
    params: ListarNotificacionesParams = {},
    opts?: RequestOpts,
  ): Promise<ApiResult<NotificacionesPagina>> =>
    toResult(
      apiAxios.get({ url: `/notificaciones${qs({ ...params })}`, config: priv(opts) }),
      adaptNotificacionesPagina,
    ),

  leer: (id: string, opts?: RequestOpts): Promise<ApiResult<void>> =>
    toResult(
      apiAxios.post({ url: `/notificaciones/${segmento(id)}/leer`, config: priv(opts) }),
      sinCuerpo,
    ),

  leerTodas: (opts?: RequestOpts): Promise<ApiResult<void>> =>
    toResult(apiAxios.post({ url: '/notificaciones/leer-todas', config: priv(opts) }), sinCuerpo),

  eliminar: (id: string, opts?: RequestOpts): Promise<ApiResult<void>> =>
    toResult(
      apiAxios.delete({ url: `/notificaciones/${segmento(id)}`, config: priv(opts) }),
      sinCuerpo,
    ),
};
